<template>
    <v-empty-state v-bind:headline="$t(`${error.statusCode}-headline`)"
                   v-bind:title="$t(`${error.statusCode}-title`)"
                   v-bind:text="$t(`${error.statusCode}-text`)"
                   image="https://media.zooingvar.net/images/zooingvar-parrot-symbol.svg" />
</template>

<script setup lang="ts">
    // LOCAL TRANSLATIONS
    const messages = {
        sv: {
            '503-headline': 'Vi är på en liten flygtur – snart tillbaka!',
            '503-title': 'HTTP 503 - Tjänsten är otillgänglig',
            '503-text': 'Just nu är sidan otillgänglig, kanske för att vi justerar våra fjädrar eller är mitt uppe i lite underhåll. Vi kommer tillbaka om en stund, redo att flyga vidare!',
        },
        en: {
            '503-headline': 'We\'re on a little flight – be back soon!',
            '503-title': 'HTTP 503 - Service Unavailable',
            '503-text': 'The page is currently unavailable, maybe because we\'re adjusting our feathers or in the middle of some maintenance. We\'ll be back shortly, ready to take flight again!',
        }
    };

    // PROPS
    const props = defineProps({
        error: Object as () => NuxtError
    });

    const {
        $i18n
    } = useNuxtApp();

    onMounted(() => {
        $i18n.mergeLocaleMessage($i18n.locale.value, messages[$i18n.locale.value]);

        useHead({
            htmlAttrs: {
                //lang: page.value?.culture || $i18n.locale.value
            },
            title: 'HTTP 503 - Service Unavailable',
            description: 'HTTP 503 - Service Unavailable'
        });

        useSeoMeta({
            title: 'HTTP 503 - Service Unavailable',
            description: 'HTTP 503 - Service Unavailable'
        });
    });
</script>